import { useTheme } from '@mui/material';

import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      color: colors.white,
      cursor: 'pointer',
    },
    iconContainer: {
      display: 'flex',
      p: 1,
      flexShrink: 0,
      '& svg': {
        width: 32,
        height: 32,
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '4px',
    },
    name: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '16px',
      letterSpacing: '0.1px',
      color: colors.white,
    },
    description: {
      fontWeight: 500,
      fontSize: 12,
      lineHeight: '16px',
      color: colors.grey,
    },
  };
};
